/**
 * @ngdoc services
 * @memberof mercury.services
 * @name multisite
 * @description Service to manage the user information
 */
angular.module('mercury.services.multisite', [])
.factory('multisite', ["$rootScope", "httpBuffer", function($rootScope, httpBuffer) {

  var _multisiteEnabled = false;
  var _multisiteDisabledCompanies = [];

  function setMultisite(enabled) {

    if (_multisiteEnabled) {
      // purge any queued http request if we're moving from a multisite report to another page
      httpBuffer.purge();
    }

    _multisiteEnabled = enabled;
    $rootScope.$broadcast('userInfoUpdated');
  }
  /**
   * Check if any urls have been registed.
   *
   * @memberof multisite
   */
  function isMultisiteEnabled() {
    return _multisiteEnabled;
  }

  /**
   * See if a company is enabled for multisite
   *
   * @memberof multisite
   */
  function isCompanyDisabled(companyId) {
    return _multisiteDisabledCompanies.indexOf(companyId) !== -1;
  }

  /**
   * Set companies enabled in multisite mode
   *
   * @memberof multisite
   */
  function disableCompany(companyId) {
    if (_multisiteDisabledCompanies.indexOf(companyId) === -1) {
      _multisiteDisabledCompanies.push(companyId);
    } else {
      _multisiteDisabledCompanies.splice(
        _multisiteDisabledCompanies.indexOf(companyId),
        1);
    }

    $rootScope.$broadcast('userInfoUpdated');
  }

  return {
    setMultisite: setMultisite,
    isMultisiteEnabled: isMultisiteEnabled,
    isCompanyDisabled: isCompanyDisabled,
    disableCompany: disableCompany
  };
}]);
